import { UnorderedListOutlined } from '@ant-design/icons';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { ItemRangeRule } from '../../../../rules/repository/item-range/ItemRange.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { OptionsTranslationSchema } from '../../translations/OptionsTranslationSchema.ts';
import { MultiSelectOption } from './components/MultiSelectOption.tsx';
import {
  getMultiSelectWidgetOptionsReferences,
  getMultiSelectWidgetReference,
} from './getMultiSelectWidgetReference.ts';
import { type IMultiSelectWidget } from './IMultiSelectWidget.ts';
import {
  MultiSelectConfigComponent,
  multiSelectInputConfigValidator,
} from './MultiSelectConfigComponent.tsx';
import { MultiSelectWidgetComponent } from './MultiSelectWidgetComponent.tsx';
import { getMultiSelectOptionsWidgetSchema } from './MultiSelectWidgetSchema.ts';

/**
 * Tipo del componente di input di testo.
 */
export const MultiSelectWidgetType: IWidgetType<IMultiSelectWidget> = {
  type: WidgetType.MultiSelect,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo scelta multipla',
  icon: <UnorderedListOutlined />,
  getReference: getMultiSelectWidgetReference,
  getSiblingReferences: getMultiSelectWidgetOptionsReferences,
  hasValue: true,
  formComponent: MultiSelectWidgetComponent,
  createFormSchema: ({ widget }) => getMultiSelectOptionsWidgetSchema(widget),
  previewComponent: MultiSelectWidgetComponent,
  optionComponent: MultiSelectOption,
  configValidator: multiSelectInputConfigValidator,
  configComponent: MultiSelectConfigComponent,
  translationSchema: tran.widget({
    ...InputCommonTranslationSchema.objectShape,
    options: OptionsTranslationSchema,
  }),
  rules: [RequiredRule, ItemRangeRule, CustomWarningsRule],
};
